module.exports = __webpack_public_path__ + "img/grocery.9f6eeac3.png";